/**
 * Imagens dos flashcards de palavras (Loja de Flashcards).
 * R2: biblioteca-backup/flashcard-images/<conceito>.webp + index.json
 * O índice é chaveado pela palavra em inglês (conceito). Por enquanto só baralhos de inglês.
 */
import React, { useEffect, useState } from 'react';

const BASE = 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/flashcard-images';
type ImageIndex = Record<string, { f: string; autor?: string; fonte?: string; link?: string }>;

let indexPromise: Promise<ImageIndex> | null = null;

export const loadFlashcardImageIndex = (): Promise<ImageIndex> => {
  if (!indexPromise) {
    indexPromise = fetch(`${BASE}/index.json`)
      .then(r => (r.ok ? r.json() : {}))
      .catch(() => {
        indexPromise = null; // tenta de novo na próxima vez
        return {};
      });
  }
  return indexPromise;
};

const toKey = (word: string) => word.toLowerCase().trim().replace(/\s+/g, '-');

/** URL da imagem do conceito em inglês, ou null se não houver. */
export const useFlashcardImage = (englishWord: string | null | undefined): string | null => {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    setUrl(null);
    if (!englishWord) return;
    let alive = true;
    loadFlashcardImageIndex().then(idx => {
      const hit = idx[toKey(englishWord)];
      if (alive && hit) setUrl(`${BASE}/${hit.f}`);
    });
    return () => { alive = false; };
  }, [englishWord]);
  return url;
};

/** Componente pronto para o verso do card: quadrado de cantos arredondados, some se não houver imagem. */
export const FlashcardImage: React.FC<{ word?: string | null; enabled: boolean }> = ({ word, enabled }) => {
  const url = useFlashcardImage(enabled ? word : null);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [url]);
  if (!url || failed) return null;
  return (
    <img
      src={url}
      alt={word || ''}
      loading="lazy"
      onError={() => setFailed(true)}
      className="w-28 h-28 sm:w-40 sm:h-40 object-cover rounded-2xl shadow-md border border-black/5 dark:border-white/10 shrink-0 mb-4"
    />
  );
};
